<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
import { Chart, Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale, BarController, LineController } from "chart.js";

// Registrar os componentes necessários
Chart.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale, BarController, LineController);

export default {
  name: "chartComponent",
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartType: {
      type: String,
      required: true,
    },
    chartReportType: {
      type: String,
      required: true,
    },
    chartTitle: {
      type: String,
      required: false,
      default: "",
    }
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    getCSSColor(variable) {
      return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    },
    returnChartFormattedType: function (value) {
      let chartLabelType;

      if (this.chartReportType == "faturamento" || this.chartReportType == "despesas" || this.chartReportType == "cancelamentos") {
        chartLabelType = `R$ ${value.toLocaleString("pt-BR", { maximumFractionDigits: 2 })}`;
      } else {
        chartLabelType = value;
      }

      return chartLabelType;
    },
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy(); // Destrói a instância anterior
      }

      if (this.chartData && this.chartData.datasets) {
        const palette = ['#3E6990', '#F26430', '#1E8E76', '#B4860A'];
        this.chartData.datasets.forEach((dataset, index) => {
          if (typeof dataset.backgroundColor === 'string' && dataset.backgroundColor.startsWith("--")) {
            dataset.backgroundColor = this.getCSSColor(dataset.backgroundColor);
          }
          if (!dataset.backgroundColor || (Array.isArray(dataset.backgroundColor) && !dataset.backgroundColor.length)) {
            dataset.backgroundColor = palette[index % palette.length];
          }
          if (!dataset.borderColor) dataset.borderColor = palette[index % palette.length];
        });
      }

      let self = this;

      this.chartInstance = new Chart(this.$refs.canvas, {
        type: this.chartType, // 'bar' ou 'line'
        data: this.chartData,
        options: {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    position: "top",
                },
                title: {
                    display: true,
                    text: this.chartTitle,
                    font: {
                        size: 20,
                    },
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            let value = context.raw || 0;
                            return self.returnChartFormattedType(value);
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: function (value) {
                            return self.returnChartFormattedType(value);
                        }
                    }
                }
            }
        }
    });
    },
  },
};
</script>

<style scoped>
canvas {
  width: 100%;
  max-height: calc(100vh - 300px);
  border: 1px solid var(--gray-3);
  border-radius: var(--radius-md);
  overflow: hidden;
  padding: var(--space-3);
}
</style>
